import {Component} from '@angular/core';

import {GeneralListComponent} from '../../general/list/generalList.component';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageService} from '../../../../shared/message.service';
import {UserRightService} from '../../../services/user-right.service';
import {UserRight} from '../../../interfaces/userRight';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-userrights',
  templateUrl: '../../general/list/generalList.component.html',
  styleUrls: ['../../general/list/generalList.component.css']
})
export class UserRightListComponent extends GeneralListComponent<UserRight> {

  constructor(
    service: UserRightService,
    router: Router,
    messagesService: MessageService,
    modalService: NgbModal,
    route: ActivatedRoute) {
    super(
      service,
      router,
      messagesService,
      route,
      modalService,
      {
        entityNameSingular: 'user right',
        entityNamePlural: 'user rights',
        formUrl: 'userright',
        listUrl: 'userrights',
        generalFormMetaName: 'user-right',
      },
    );
  }
}
